import { detectPlatform } from '@myrealtrip/device-detect';
import { PLATFORM } from '../constants';

function getMobilePlatform(userAgent?: string) {
  // SSR
  if (typeof navigator === 'undefined') {
    return null;
  }

  const targetUserAgent = userAgent || navigator?.userAgent;
  const platform = detectPlatform(targetUserAgent);

  if (platform.isIos) {
    return PLATFORM.IOS;
  }

  return PLATFORM.ANDROID;
}

export default getMobilePlatform;
